// extracted by mini-css-extract-plugin
export default {"container":"fndF5","betSlipContent":"TwKdA","backdrop":"KVGU5","emptyBetSlip":"Z8xjZ","footer":"diKmC","bigStake":"kes9J","scrollbarBetSlip":"FrRmB"};